export function saveBlob(blob: Blob, name: string) {
    const link = document.createElement("a");
    link.download = name;
    link.href = URL.createObjectURL(blob);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
